<template>
  <a
    v-if="isExternalLink"
    :href="path"
    :target="isExternalLink ? '_blank' : target"
    :download="download ? '' : undefined"
    :rel="rel"
  >
    <slot />
  </a>
  <NuxtLink v-else :to="localePath(path)">
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  to?: string;
  target?: string;
  download?: boolean;
  rel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  target: '_self',
  rel: '',
  to: '',
  download: false,
});

const localePath = useLocalePath();

const isEmptyToProp = computed(() => [undefined, null, ''].includes(props.to));
const isExternalLink = computed(() => {
  if (!isEmptyToProp.value)
    return props.to?.startsWith('https://') || props.to?.startsWith('http://');
  return false;
});

const path = computed(() => {
  if (!isEmptyToProp.value) {
    if (
      props.to?.endsWith('/') ||
      props.to?.includes('.') ||
      props.to?.includes('#')
    ) {
      return props.to;
    }
    return `${props.to}/`;
  }
  return '#';
});
</script>
